{
  "common": {
    "memberCenter": "Central do membro",
    "points": "Pontos",
    "level": "Nível",
    "coupons": "Cupons",
    "checkin": "Check-in diário",
    "history": "Histórico",
    "balance": "Saldo",
    "expire": "Expirar",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "loading": "Carregando...",
    "noData": "Sem dados",
    "retry": "Tentar novamente",
    "success": "Sucesso",
    "failed": "Falhou"
  },
  "points": {
    "earn": "{amount} pontos ganhos",
    "spend": "{amount} pontos gastos",
    "balance": "Saldo atual: {amount} pontos",
    "expired": "{amount} pontos expirados",
    "estimated": "Estimado (aguardando confirmação)"
  },
  "level": {
    "current": "Nível atual: {name}",
    "nextLevel": "Próximo nível: {name}",
    "progress": "{current}/{target} para o próximo nível",
    "upgraded": "Parabéns! Promovido para {name}"
  },
  "coupon": {
    "claim": "Resgatar",
    "claimed": "Resgatado",
    "expired": "Expirado",
    "used": "Usado",
    "validUntil": "Válido até {date}",
    "threshold": {
      "none": "Sem valor mínimo",
      "min": "Pedido mínimo {amount}"
    }
  },
  "checkin": {
    "today": "Check-in de hoje",
    "done": "Check-in feito",
    "streak": "{days} dias consecutivos",
    "reward": "+{amount} pontos"
  },
  "errors": {
    "network": "Erro de rede, tente novamente",
    "unauthorized": "Por favor, faça login",
    "serverError": "Erro do servidor, tente novamente mais tarde",
    "timeout": "Tempo esgotado"
  },
  "ui": {
    "memberCenter": {
      "loading": "Carregando...",
      "avatarAlt": "Avatar do membro",
      "pointsBalance": "Meus pontos",
      "menuLabel": "Navegação do membro",
      "menu": {
        "pointsDetail": "Histórico de pontos",
        "levelDetail": "Benefícios do nível",
        "coupons": "Meus cupons",
        "referral": "Convidar amigos",
        "checkin": "Check-in diário",
        "orders": "Meus pedidos",
        "exchange": "Loja de pontos",
        "address": "Meus endereços",
        "profile": "Meu perfil",
        "account": "Configurações da conta"
      }
    },
    "pointsDetail": {
      "title": "Histórico de pontos",
      "empty": "Sem histórico de pontos",
      "loading": "Carregando...",
      "noMore": "Sem mais registros",
      "listLabel": "Transações de pontos",
      "status": {
        "pending": "Pendente",
        "active": "Ativo",
        "used": "Usado",
        "expired": "Expirado"
      }
    },
    "levelProgress": {
      "loading": "Carregando...",
      "maxLevel": "Nível máximo atingido",
      "progressLabel": "Progresso do nível",
      "noBenefits": "Sem benefícios",
      "nextLevel": "Próximo nível: {name}",
      "benefitsTitle": "Meus benefícios"
    },
    "couponList": {
      "title": "Meus cupons",
      "tabsLabel": "Categorias de cupons",
      "listLabel": "Lista de cupons",
      "empty": "Sem cupons disponíveis",
      "freeShipping": "Frete grátis",
      "giftValue": "Presente",
      "discountValue": "{value}% de desconto",
      "type": {
        "discount": "Desconto",
        "cash": "Dinheiro",
        "shipping": "Frete",
        "gift": "Presente"
      },
      "tab": {
        "unused": "Não utilizado",
        "used": "Usado",
        "expired": "Expirado",
        "claimable": "Resgatar"
      },
      "loadingClaimable": "Carregando...",
      "noClaimable": "Nenhum cupom disponível",
      "claiming": "Resgatando...",
      "claim": "Resgatar",
      "stockInfo": "{remaining} restantes",
      "stockUnlimited": "Ilimitado",
      "minOrder": "Mín. {amount}"
    },
    "referralShare": {
      "loading": "Carregando...",
      "title": "Convidar amigos",
      "shareTitle": "Convide amigos e ganhe pontos",
      "shareText": "Cadastre-se agora e receba um presente!",
      "invitedCount": "Convidados",
      "rewardPoints": "Pontos ganhos",
      "codeLabel": "Meu código de indicação",
      "linkLabel": "Link de indicação",
      "copy": "Copiar",
      "copyCode": "Copiar código",
      "share": "Compartilhar",
      "rewardHint": "Ganhe {points} pontos por amigo convidado",
      "tabShare": "Convidar",
      "tabRecords": "Registros",
      "loadingRecords": "Carregando...",
      "noRecords": "Nenhum convite",
      "anonymousUser": "Anônimo",
      "prevPage": "Anterior",
      "nextPage": "Próximo",
      "recordsLabel": "Lista de convites",
      "status": {
        "registered": "Registrado",
        "first_order": "Primeiro pedido",
        "rewarded": "Recompensado"
      }
    },
    "checkinCalendar": {
      "loading": "Carregando...",
      "checking": "Fazendo check-in...",
      "checkin": "Fazer check-in",
      "alreadyChecked": "Já fez check-in hoje",
      "day": "{count} dias",
      "title": "Check-in diário",
      "streak": "{days} dias consecutivos",
      "calendarLabel": "Calendário de check-in",
      "rewardsTitle": "Recompensas de sequência",
      "rewardsLabel": "Lista de recompensas",
      "weekday": {
        "sun": "Dom",
        "mon": "Seg",
        "tue": "Ter",
        "wed": "Qua",
        "thu": "Qui",
        "fri": "Sex",
        "sat": "Sáb"
      },
      "prevMonth": "Mês anterior",
      "nextMonth": "Próximo mês",
      "monthDays": "{count} dias este mês",
      "monthPoints": "Pontos do mês"
    },
    "orderList": {
      "loading": "Carregando pedidos...",
      "title": "Histórico de pedidos",
      "noOrders": "Nenhum pedido",
      "listLabel": "Lista de pedidos",
      "prevPage": "Anterior",
      "nextPage": "Próximo",
      "typePoints": "Pontos",
      "typeGrowth": "Crescimento",
      "bizType": {
        "Order_Pay": "Pagamento do pedido",
        "Order_Refund": "Reembolso"
      },
      "status": {
        "pending": "Pendente",
        "active": "Ativo",
        "invalid": "Inválido",
        "used": "Usado",
        "expired": "Expirado"
      }
    },
    "addressManager": {
      "title": "Meus endereços",
      "add": "Adicionar",
      "empty": "Nenhum endereço",
      "default": "Padrão",
      "setDefault": "Definir padrão",
      "edit": "Editar",
      "delete": "Excluir"
    },
    "accountSettings": {
      "title": "Configurações",
      "dataExport": {
        "title": "Exportar dados",
        "desc": "Baixar uma cópia dos seus dados",
        "button": "Solicitar exportação",
        "processing": "Processando..."
      },
      "deleteAccount": {
        "title": "Excluir conta",
        "desc": "Excluir permanentemente sua conta e dados",
        "button": "Excluir conta",
        "confirm": "Esta ação não pode ser desfeita. Todos os seus dados serão excluídos.",
        "confirmButton": "Sim, excluir",
        "cancel": "Cancelar"
      }
    },
    "checkout": {
      "points": {
        "title": "Desconto de pontos",
        "unit": "pts",
        "available": "Disponível",
        "deduct": "Descontar"
      },
      "coupon": {
        "title": "Cupom",
        "none": "Sem cupom"
      },
      "summary": {
        "order": "Total do pedido",
        "discount": "Desconto",
        "total": "A pagar"
      }
    },
    "profile": {
      "form": {
        "nickname": "Apelido",
        "avatar": "URL do avatar",
        "locale": "Idioma",
        "save": "Salvar",
        "saving": "Salvando..."
      }
    },
    "auth": {
      "login": {
        "emailLabel": "E-mail",
        "passwordLabel": "Senha",
        "submit": "Entrar",
        "createAccount": "Criar conta",
        "forgotPassword": "Esqueceu a senha?",
        "orDivider": "ou"
      },
      "register": {
        "emailLabel": "E-mail",
        "passwordLabel": "Senha",
        "confirmPasswordLabel": "Confirmar senha",
        "passwordHint": "No mínimo 8 caracteres, com letras e números",
        "submit": "Criar conta",
        "hasAccount": "Já tem uma conta? Entrar",
        "passwordMismatch": "As senhas não coincidem",
        "submitting": "Criando..."
      },
      "oauth": {
        "continueWith": "Continuar com {provider}"
      },
      "verify": {
        "title": "Verifique seu email",
        "description": "Enviamos um código de verificação para {email}",
        "digitLabel": "Dígito {index}",
        "resend": "Reenviar código",
        "resendCountdown": "Reenviar ({countdown}s)",
        "backToRegister": "Voltar ao cadastro"
      },
      "forgot": {
        "title": "Redefinir senha",
        "description": "Digite seu e-mail e enviaremos um código de verificação.",
        "emailLabel": "E-mail",
        "submit": "Enviar código",
        "backToLogin": "Voltar ao login"
      }
    },
    "error": {
      "network": "Erro de rede, tente novamente",
      "retry": "Tentar novamente",
      "retryLabel": "Recarregar"
    }
  },
  "sdk": {
    "error": {
      "210900": "Parâmetros inválidos",
      "210901": "ID do inquilino é obrigatório",
      "210902": "Muitas solicitações, por favor tente mais tarde",
      "210903": "Não autorizado",
      "210904": "Token expirado",
      "210905": "Token inválido",
      "210906": "Falha na atualização do token",
      "210907": "Falha na troca de token da plataforma",
      "210908": "Token de atualização inválido",
      "210909": "Token de atualização expirado",
      "210911": "Membro não encontrado",
      "210912": "Informações de nível não encontradas",
      "210920": "Este e-mail já está registrado",
      "210921": "Senha muito fraca: pelo menos 8 caracteres com letras e números",
      "210922": "Código de verificação enviado com muita frequência, por favor tente mais tarde",
      "210923": "Código de verificação inválido ou expirado",
      "210924": "Informações de registro expiradas, por favor registre-se novamente",
      "210925": "E-mail ou senha incorretos",
      "210926": "E-mail não verificado, por favor verifique primeiro",
      "210927": "Falha na autenticação OAuth",
      "210928": "Estado OAuth inválido ou expirado",
      "210929": "Método de login não suportado",
      "210930": "Falha na criação do usuário",
      "210931": "Falha no cálculo do desconto",
      "210951": "Falha na consulta do saldo de pontos",
      "210952": "Falha na consulta de transações de pontos",
      "210953": "Falha no acúmulo de pontos",
      "210954": "Falha na ativação de pontos",
      "210955": "Falha no gasto de pontos",
      "210956": "Saldo de pontos insuficiente",
      "210957": "Livro de pontos não encontrado",
      "210958": "O status dos pontos não permite esta operação",
      "210971": "Cupom esgotado",
      "210972": "Cupom já resgatado",
      "210981": "Falha na escrita da fila de mensagens",
      "210982": "Falha na sincronização do serviço interno",
      "210983": "Produto de troca não encontrado",
      "210984": "Falha no resgate",
      "210985": "Código de indicação não encontrado",
      "210986": "Falha na vinculação de indicação",
      "210987": "Indicador não encontrado",
      "210988": "Não é possível convidar a si mesmo",
      "210989": "Falha ao resgatar o cupom",
      "210990": "Já fez check-in hoje",
      "210991": "Falha no check-in",
      "211001": "Falha na verificação de assinatura do webhook",
      "211002": "Plataforma webhook não suportada",
      "211003": "Solicitação webhook duplicada",
      "211004": "Segredo webhook não configurado",
      "211005": "Carimbo de data/hora do webhook expirado",
      "211900": "Operação falhou, por favor tente novamente",
      "211901": "Falha na autenticação",
      "211902": "Conta não vinculada",
      "211903": "Acesso negado",
      "211904": "Configuração não encontrada",
      "211905": "Escopo de configuração inválido",
      "211906": "Função não encontrada",
      "211907": "Função do sistema não pode ser excluída",
      "211908": "Sem acesso a este inquilino",
      "211909": "Falha na validação",
      "211910": "Recurso não encontrado",
      "211911": "Membro não encontrado",
      "211912": "Conflito de identidade, por favor entre em contato com o suporte",
      "211913": "Falha na ativação da conta sombra",
      "211914": "Registro de revisão não encontrado",
      "211915": "O status do registro de revisão não é pendente",
      "211916": "OneID não encontrado",
      "211917": "Falha ao desvincular OneID",
      "211931": "Configuração de nível não encontrada",
      "211932": "Nível possui membros associados, não é possível excluir",
      "211933": "Falha na validação da condição de upgrade de nível",
      "211934": "A sequência de níveis deve ser contínua",
      "211951": "Transição de status do livro inválida",
      "211952": "Saldo de pontos insuficiente",
      "211953": "Registro do livro não encontrado",
      "211954": "Transação de pontos duplicada",
      "211955": "Valor de pontos inválido",
      "211956": "Dedução de pontos excede o limite máximo",
      "211957": "Pontos abaixo do limite mínimo",
      "211958": "Regra de acúmulo de pontos não configurada",
      "211959": "Falha na ativação de pontos: status não é pendente",
      "211960": "Acesso negado à transação de pontos",
      "211961": "Pontos já expirados",
      "211962": "Regra de crescimento não configurada",
      "211971": "Modelo de cupom não encontrado",
      "211972": "Status do modelo de cupom inválido",
      "211973": "Limite de cupons por usuário excedido",
      "211974": "Cota total de cupons excedida",
      "211975": "Status de resgate do cupom inválido",
      "211976": "Cupom expirado",
      "211977": "Modelo de cupom possui cupons emitidos, não é possível excluir",
      "211981": "Tarefa de push não encontrada",
      "211982": "O status da tarefa de push não permite edição",
      "211983": "O status da tarefa de push não permite cancelamento",
      "211984": "Modelo de push não encontrado",
      "211985": "O público-alvo do push está vazio",
      "211991": "Serviço ocupado, por favor tente mais tarde",
      "211992": "Falha na publicação da mensagem",
      "211993": "Mensagem entrou na fila de mensagens mortas",
      "network": "Erro de rede, por favor verifique sua conexão",
      "timeout": "Tempo limite excedido, por favor tente novamente",
      "aborted": "Solicitação cancelada",
      "parse": "Erro ao analisar a resposta",
      "unauthorized": "Por favor faça login primeiro",
      "config": "Erro de inicialização do SDK",
      "unknown": "Ocorreu um erro desconhecido"
    }
  },
  "exchange": {
    "store": {
      "title": "Loja de pontos",
      "myOrders": "Minhas trocas",
      "empty": "Nenhum produto disponível",
      "points": "pontos",
      "stock": "Estoque",
      "back": "Voltar",
      "redeem": "Resgatar",
      "soldOut": "Esgotado",
      "noOrders": "Nenhuma troca",
      "status": {
        "pending": "Pendente",
        "completed": "Concluído",
        "cancelled": "Cancelado"
      }
    }
  },
  "message": {
    "center": {
      "title": "Mensagens",
      "empty": "Nenhuma mensagem"
    },
    "type": {
      "system": "Sistema",
      "marketing": "Promoções",
      "transaction": "Transação",
      "activity": "Atividade"
    }
  }
}
